export const navigateToPrintReport = (clientId: string) => {
  const printUrl = `/clients/${clientId}/onboarding/report/print`;
  window.open(printUrl, '_blank');
};

export const printCurrentPage = () => {
  window.print();
};
